import { render, staticRenderFns } from "./facets.vue?vue&type=template&id=b5743640&scoped=true"
import script from "./facets.vue?vue&type=script&lang=js"
export * from "./facets.vue?vue&type=script&lang=js"
import style0 from "./facets.vue?vue&type=style&index=0&id=b5743640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5743640",
  null
  
)

export default component.exports